import { render } from "./ReportDetailed.vue?vue&type=template&id=4908a1b8&scoped=true"
import script from "./ReportDetailed.vue?vue&type=script&lang=js"
export * from "./ReportDetailed.vue?vue&type=script&lang=js"

import "./ReportDetailed.vue?vue&type=style&index=0&id=4908a1b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4908a1b8"

export default script